const ColourExtractionSettings = ({ config, onChange }) => {
  const update = (key, value) => {
    onChange({ ...config, [key]: value });
  };

  //const inputClass = "px-3 py-1 rounded border border-slate-300 w-full";

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-sm">
      {[
        {
          label: "Number of Colours",
          description:
            "Got more than 10 dominant colours in your image? Bump this up. Just know — it’ll take a bit longer to extract, ok?",
          value: config.num_colors,
          min: 1,
          max: 20,
          step: 1,
          onChange: (e) => {
            const value = e.target.value;
            update("num_colors", value === "" ? "" : parseInt(value));
          },
        },
        {
          label: "Colour Variations",
          description:
            "Think I missed a core shade? Oops. Raise this and I’ll look harder for all different shades.",
          value: config.oversampling,
          step: 0.1,
          onChange: (e) => {
            const value = e.target.value;
            update("oversampling", value === "" ? "" : parseFloat(value));
          },
        },
        {
          label: "Colour Similarity Threshold",
          description:
            "Did the design have too many similar shades? I might have merged some. Lower this and I’ll keep similar colours separate.",
          value: config.merge_threshold,
          min: 1,
          max: 100,
          step: 1,
          onChange: (e) => {
            const value = e.target.value;
            update("merge_threshold", value === "" ? "" : parseFloat(value));
          },
        },
        {
          label: "Min Pixel Threshold",
          description:
            "Seeing random tiny colours from the background or small labels? Raise this to filter out those irrelevant specks.",
          value: config.min_pixel_thresh,
          step: 0.01,
          min: 0,
          max: 0.2,
          onChange: (e) => {
            const value = e.target.value;
            update(
              "min_pixel_thresh",
              value === "" ? "" : parseFloat(e.target.value)
            );
          },
        },
      ].map((field, idx) => (
        <div key={idx} className="flex flex-col gap-1">
          <label className="text-slate-400 tracking-wide font-medium">
            {field.label}
          </label>
          <input
            type="number"
            value={field.value}
            min={field.min}
            max={field.max}
            step={field.step}
            onChange={field.onChange}
            onWheel={(e) => e.target.blur()}
            className="w-full px-3 py-2 rounded-md bg-slate-950 text-white border border-slate-700 focus:outline-none focus:ring-2 focus:ring-vedicGold text-sm font-mono shadow-innerGlow"
          />
          {field.description && (
            <p className="text-xs text-slate-500 leading-snug mt-1">
              {field.description}
            </p>
          )}
        </div>
      ))}
    </div>
  );
};

export default ColourExtractionSettings;
